import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			loading: false,
			showCate: false,
			host: '',
			deviceType: 'mobile',
			showDebug: false,
			isAuth: false,
			userInfo: null,
			avatar: '',
			adsensConfig: {},
			domainConfig: {},
			taskId: -1, // -1 表示当前无任务
			msg: 'downloading...',
			inTop: true
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
		}
	})
}
